<template>
  <div :class="['section', $style.uploadFailContainer]">
    <div class="content has-text-centered">
      <img src="@/assets/images/error_dragndrop@2x.png" />
      <div :class="$style.uploadDetails">
        <p :class="['has-text-weight-bold', $style.uploadHeader]">
          Error! {{ message }}
        </p>
        <p :class="$style.uploadHeaderAlt">
          Failed to upload file<br />
          <a @click="$emit('retryUpload')">Please try again</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({})
export default class UploadError extends Vue {
  @Prop(String) private message!: string;
}
</script>

<style lang="scss" module>
@import './style.scss';
</style>
